import { Card, CardContent } from "@/components/ui/card";
import { MessageSquare, Mic2, Users } from "lucide-react";
import { motion } from "framer-motion";

const offers = [
  {
    icon: MessageSquare,
    iconBg: "bg-accent/10",
    iconColor: "text-accent",
    title: "Condividi ciò che conta, in un dialogo reale",
    description: "I tuoi cari potranno parlarti, farti domande e ricevere risposte. Come se fossi proprio lì.",
  },
  {
    icon: Mic2,
    iconBg: "bg-success/10",
    iconColor: "text-success",
    title: "Preserva te stesso come vuoi essere ascoltato",
    description: "Scegli cosa rimane: le tue storie, i tuoi consigli, le battute, la tua filosofia di vita.",
  },
  {
    icon: Users,
    iconBg: "bg-primary/10",
    iconColor: "text-primary",
    title: "Esserci per chi resterà",
    description: "La tua presenza aiuterà nei momenti difficili, sosterrà le scelte, ricorderà le radici.",
  },
];

export const WhatWeOffer = () => {
  return (
    <section className="py-24 lg:py-32 relative">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-6"
        >
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight mb-6">
            Cosa offriamo
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Creiamo la tua presenza digitale vivente. Non è un bot. Non è un monumento.
            Sei tu — nella logica, nel modo, nella voce e nel significato.
            È restare connessi. Anche quando non ci sei più.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 mt-16">
          {offers.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.12 }}
            >
              <Card className="bg-card border-border/40 shadow-card hover:shadow-medium transition-shadow duration-500 h-full">
                <CardContent className="p-8 lg:p-10 flex flex-col h-full">
                  <div className={`w-14 h-14 rounded-xl ${item.iconBg} flex items-center justify-center mb-6`}>
                    <item.icon className={`w-7 h-7 ${item.iconColor}`} />
                  </div>
                  <h3 className="font-serif text-lg font-semibold text-foreground mb-3 leading-snug">{item.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed mt-auto">{item.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
